import Component from 'vue-class-component'

import './audit-campaign-pop-up.scss'

import { ReactiveVue } from '@skinsoft/reactive-vue'

import { AuditCampaignFeaturedList } from '../../audit-campaign-search/audit-campaign-featured-list'

import { AuditCampaignDataStore, RecordDataStore } from '@skinsoft/entity'

import { NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC } from '../../../../busTopics'

import { from, of } from 'rxjs'
import { catchError, concatMap, delay, mergeMap, pluck, retryWhen, tap } from 'rxjs/operators'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
@Component({
    components: {
        auditCampaignFeaturedList: AuditCampaignFeaturedList
    },
    props: ['linkableItemId', 'linkableItemType'],
    template: require('./audit-campaign-pop-up.html')
})
export class AuditCampaignPopUp extends ReactiveVue {
    private linkableItemId: string
    private linkableItemType: string

    private $auditCampaignDataStore: AuditCampaignDataStore
    private $recordDataStore: RecordDataStore

    private loadingIcon = faCircleNotch

    private loading = false
    private campaignCount: number = 0
    private pageNumber: number = 1
    private currentPage: number = 1

    private searchParams = {
        nbResults: 5,
        queryText: '',
        sortAsc: true,
        sortType: '5e2713835111f87e825edddc',
        startAt: 0
    }

    private mounted() {
        this.open()
        this.subscribeToBus(NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC, res => {
            this.campaignCount = res.payload.totalResults
            this.pageNumber = Math.ceil(this.campaignCount / this.searchParams.nbResults)
            this.currentPage = this.searchParams.startAt + 1
            this.unsubscribeFrom(NB_CAMPAIGNS_SEARCH_RESULT_CHANGED_TOPIC)
        })
    }

    private open() {
        (this.$refs.modal as any).show()
    }

    private addToCampaign(auditCampaignId: string) {
        this.loading = true
        this.$auditCampaignDataStore.fetchOne(auditCampaignId).pipe(
            tap(auditCampaign => from(this.$auditCampaignDataStore.addItem(auditCampaign, this.linkableItemId, this.linkableItemType))),
            concatMap(value => {
                return of(value).pipe(
                    mergeMap(() => this.$auditCampaignDataStore.fetchOne(auditCampaignId)),
                    pluck('auditProjectSchema', 'auditReports'),
                    mergeMap(allReports => {
                        return this.$recordDataStore.searchAll(null, null, 1, ['AuditRecord', 'Recolement'], 0,
                        [{
                            leftCriteria: {
                                entityField: '5d5d3797bbffbb20bbcca5fa',// linked item
                                operator: 'equals',
                                type: 'criteria',
                                value: {
                                    completeSearch: false,
                                    refId: this.linkableItemId,
                                    type: 'ref'
                                }
                            },
                            linkOperator: null,
                            rightCriteria: null,
                            type: 'requestSearch'
                        }], allReports)
                    }),
                    tap(res => {
                        if (res.totalSize === 0) {
                            throw new Error('Report not yet created')
                        }
                    }),
                    catchError(() => this.$auditCampaignDataStore.fetchOne(auditCampaignId).pipe(
                        pluck('auditProjectSchema', 'auditReports'),
                        mergeMap(allReports => this.$recordDataStore.searchAllOffline(null, null, 1, ['AuditRecord', 'Recolement'], 0,
                            [{
                                leftCriteria: {
                                    entityField: '5d5d3797bbffbb20bbcca5fa',// linked item
                                    operator: 'equals',
                                    type: 'criteria',
                                    value: {
                                        completeSearch: false,
                                        refId: this.linkableItemId,
                                        type: 'ref'
                                    }
                                },
                                linkOperator: null,
                                rightCriteria: null,
                                type: 'requestSearch'
                            }], allReports)
                        )
                    )),
                    tap(res => {
                        if (res.totalSize === 0) {
                            throw new Error('Report not yet created')
                        }
                    }),
                    retryWhen(e => e.pipe(delay(1000))),
                    pluck('allData', '0', 'id')
                )
            })
        ).subscribe(target => {
            this.$emit('close')
            this.$router.push(`/record/${auditCampaignId}/${target}`)
        })
    }

    private changePage(forward: boolean) {
        if (forward) {
            if (this.canMoveForward) {
                ++this.searchParams.startAt
            }
        } else if (this.canMoveBackward) {
            --this.searchParams.startAt
        }
    }

    private get canMoveBackward(): boolean {
        return this.searchParams.startAt > 0
    }

    private get canMoveForward(): boolean {
        return this.searchParams.startAt + 1 < Math.floor(this.campaignCount / this.searchParams.nbResults) + (this.campaignCount % this.searchParams.nbResults ? 1 : 0)
    }
}